import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdminAuthenticated, logoutAdmin, validateAdminSession } from "../api/auth";

export default function AdminRoute({ children }) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let active = true;

    if (!isAdminAuthenticated()) {
      setIsChecking(false);
      return undefined;
    }

    validateAdminSession().then((valid) => {
      if (!active) return;
      if (!valid) logoutAdmin();
      setIsAuthenticated(valid);
      setIsChecking(false);
    }).catch(() => {
      if (!active) return;
      logoutAdmin();
      setIsChecking(false);
    });

    return () => {
      active = false;
    };
  }, []);

  if (isChecking) return <div aria-busy="true" />;

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
